import { render } from "./Heaters.vue?vue&type=template&id=4138a532&scoped=true"
import script from "./Heaters.vue?vue&type=script&lang=js"
export * from "./Heaters.vue?vue&type=script&lang=js"

import "./Heaters.vue?vue&type=style&index=0&id=4138a532&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dymek\\Desktop\\Projects\\Lusterka Adam\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4138a532"]])

export default __exports__